import { PROVIDER } from './types';
import { pathByRouteName } from './routes';

export const isProviderUser = user => user?.attributes?.profile?.publicData?.userType === PROVIDER;

/**
 * Route name for the default post-login redirect when no explicit `from` URL is set.
 */
export const defaultPostLoginRouteName = user =>
  isProviderUser(user) ? 'DashboardPage' : 'LandingPage';

export const defaultPostLoginPath = (user, routeConfiguration) => {
  const routeName = defaultPostLoginRouteName(user);
  return (
    pathByRouteName(routeName, routeConfiguration) || (isProviderUser(user) ? '/dashboard' : '/')
  );
};
